export default __webpack_public_path__ + "static/media/title_correct_order.01275cf8.svg";